import { lazy, useState } from "react";
import PropTypes from "prop-types";
import ProcessRow from "../ProcessRow";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
const _handleKeikkaModal = import(
  "src/pages/steps/StepTilaus/Modals/handleKeikka/HandleKeikkaModal"
);
const HandleKeikkaModal = lazy(() => _handleKeikkaModal);

export default function ProcessRowVastaanotto(props) {
  const isConfirmed = props.thisProcess.betonitoimijaTilausVastaanotettu.isConfirmed;
  const confirmDate = props.thisProcess.betonitoimijaTilausVastaanotettu.confirmDate;
  const [handleKeikkaModalIsOpen, setHandleKeikkaModalIsOpen] = useState(false);
  const handleKlik = () => setHandleKeikkaModalIsOpen(true);

  function getTip() {
    return "Avaa tilauksen vastaanotto- ja käsittelyikkuna";
  }
  return (
    <>
      <LazyLoader>
        <HandleKeikkaModal
          open={handleKeikkaModalIsOpen}
          closeModal={() => setHandleKeikkaModalIsOpen(false)}
          keikkaData={props.thisProcess.keikkaData}
          setKeikkaData={props.setKeikkaData}
        />
      </LazyLoader>
      <ProcessRow
        txt="Tilaus vastaanotettu"
        tip={getTip()}
        done={isConfirmed}
        pvm={confirmDate}
        onClick={() => handleKlik()}
        aria-label="Tilaus vastaanotettu"
        helpId="processRowVastaanotto"
      />
    </>
  );
}

ProcessRowVastaanotto.propTypes = {
  thisProcess: PropTypes.object,
  setThisProcess: PropTypes.func,
  setKeikkaData: PropTypes.func,
};
